import {
	GET_LIST_SUBCATEGORIES,
	GET_DETAIL_SUBCATEGORIES,
	ADD_SUBCATEGORIES,
	UPDATE_SUBCATEGORIES,
	DELETE_SUBCATEGORIES,
	SUBCATEGORIES_ERROR,
	NEW_SUBCATEGORIES,
	FETCHING_SUBCATEGORIES,
	GET_OPTION_LIST_SUBCATEGORIES
} from '../constants';

const initialState = {
	list: [],
	options: [],
	detail: {},
	isFetch: false,
	isOptionsFetch: false,
	isSubmit: false,
	error: null,
	success: null,
};

const onGetSubcategoriesList = (lastState, payload) => {
	const { data, message, status_code, per_page, next_cursor, prev_cursor } = payload;
	const items = Array.isArray(data) ? data : (data && data.data ? data.data : []);

	return {
		...lastState,
		error: null,
		success: null,
		detail: {},
		list: {
			data: items,
			per_page,
			next_cursor,
			prev_cursor,
			message,
			status_code: status_code || 200,
		},
	};
};

const onGetDetailSubcategories = (lastState, payload) => {
	const { data, message, status_code } = payload;
	const detailData = data && typeof data === 'object' && !Array.isArray(data) ? data : payload;

	return {
		...lastState,
		error: null,
		success: null,
		detail: { ...detailData, message, status_code: status_code || 200 },
	};
};

const onGetSubcategoryOptions = (lastState, payload) => {
	const { data } = payload;
	const items = Array.isArray(data) ? data : (data && data.data ? data.data : []);
	const options = items.map(item => ({ value: item.id, label: item.name }));

	return { ...lastState, options, isOptionsFetch: false, error: null, success: null };
};

const onFetchingSubcategories = (lastState, payload) => {
	if (payload.type === 'fetch_options') {
		return { ...lastState, isOptionsFetch: payload.status };
	}
	if (payload.type === 'fetch') {
		return { ...lastState, isFetch: payload.status };
	} else if (payload.type === 'submit') {
		return { ...lastState, isSubmit: payload.status };
	}
	return { ...lastState, isFetch: false, isSubmit: false };
};

const onSubcategoriesError = (lastState, payload) => {
	const error = payload.error || payload;

	return { ...lastState, error, success: null };
};

const onAddSubcategories = (lastState, payload) => {
	const { data, message, status_code } = payload;
	const detailData = data && typeof data === 'object' && !Array.isArray(data) ? data : payload;

	return {
		...lastState,
		detail: { ...detailData, message, status_code: status_code || 201 },
		success: 'Insert has been successfully!',
		error: null
	};
};

const onUpdateSubcategories = (lastState, payload) => {
	const { data, message, status_code } = payload;
	const detailData = data && typeof data === 'object' && !Array.isArray(data) ? data : payload;

	return {
		...lastState,
		detail: { ...detailData, message, status_code: status_code || 200 },
		success: 'Update has been successfully!',
		error: null
	};
};

const onDeleteSubcategories = (lastState, payload) => {
	const { data, message, status_code } = payload;
	return { ...lastState, detail: { ...data, message, status_code, delete: true }, success: 'Delete has been successfully!', error: null };
};

const subcategoriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_LIST_SUBCATEGORIES: return onGetSubcategoriesList(state, action.payload);
		case GET_DETAIL_SUBCATEGORIES: return onGetDetailSubcategories(state, action.payload);
		case FETCHING_SUBCATEGORIES: return onFetchingSubcategories(state, action.payload);
		case SUBCATEGORIES_ERROR: return onSubcategoriesError(state, action.payload);
		case UPDATE_SUBCATEGORIES: return onUpdateSubcategories(state, action.payload);
		case ADD_SUBCATEGORIES: return onAddSubcategories(state, action.payload);
		case DELETE_SUBCATEGORIES: return onDeleteSubcategories(state, action.payload);
		case GET_OPTION_LIST_SUBCATEGORIES: return onGetSubcategoryOptions(state, action.payload);
		case NEW_SUBCATEGORIES: return initialState;
		default: return state;
	}
};

export default subcategoriesReducer;
